export const DateFns = {
  toISODate(date: Date) {
    const mm = date.getMonth() + 1 // getMonth() is zero-based
    const dd = date.getDate()
    return [date.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd].join('-')
  },
  addDays(date: string, days: number) {
    const d = new Date(`${date}T00:00Z`)
    d.setUTCDate(d.getUTCDate() + days)
    const result = d.toISOString().slice(0, 10)
    return result
  },
  getDate(date: string) {
    const d = new Date(`${date}T00:00Z`)
    return d.getUTCDate()
  },
  getMonth(date: string) {
    const d = new Date(`${date}T00:00Z`)
    return d.getUTCMonth() + 1
  },
  isEqualOrBefore(date: string, date2: string) {
    const d = new Date(`${date}T00:00Z`)
    const d2 = new Date(`${date2}T00:00Z`)
    return d.getTime() <= d2.getTime()
  },
  isBefore(date: string, date2: string) {
    const d = new Date(`${date}T00:00Z`)
    const d2 = new Date(`${date2}T00:00Z`)
    return d.getTime() < d2.getTime()
  },
  isEqualOrAfter(date: string, date2: string) {
    const d = new Date(`${date}T00:00Z`)
    const d2 = new Date(`${date2}T00:00Z`)
    return d.getTime() >= d2.getTime()
  },
  getDayOfWeek(date: string) {
    const d = new Date(`${date}T00:00Z`)
    return d.getDay()
  },
  toYearMonth(date: string) {
    const d = new Date(`${date}T00:00Z`)
    const mm = d.getUTCMonth() + 1 // getMonth() is zero-based
    return [d.getUTCFullYear(), (mm > 9 ? '' : '0') + mm].join('-')
  },
  getDatesInRange(start: string, end: string) {
    const startDate = new Date(`${start}T00:00Z`)
    const endDate = new Date(`${end}T00:00Z`)
    if (startDate.getTime() > endDate.getTime()) {
      throw new Error('Invalid Range')
    }
    let currentDate = startDate
    const dates: Date[] = []
    while (currentDate.getTime() <= endDate.getTime()) {
      dates.push(currentDate)
      currentDate = new Date(currentDate.setUTCDate(currentDate.getUTCDate() + 1))
    }
    return dates.map((d) => DateFns.toISODate(d))
  }
}
export const YearMonthFns = {
  toYearMonth(date: Date) {
    const mm = date.getMonth() + 1 // getMonth() is zero-based
    return [date.getFullYear(), (mm > 9 ? '' : '0') + mm].join('-')
  },
  getMonthName(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    return [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ][date.getMonth()]
  },
  getAllMonthsInYear(year: number): string[] {
    // gives every year month in the given year
    return Array.from({ length: 12 }).map((_, i) => `${year}-${(i + 1).toString().padStart(2, '0')}`)
  },
  getMonthNumber(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    return date.getMonth() + 1
  },
  getYear(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    return date.getFullYear()
  },
  getNext(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    date.setMonth(date.getMonth() + 1)
    return YearMonthFns.toYearMonth(date)
  },
  getNextYear(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    date.setFullYear(date.getFullYear() + 1)
    return YearMonthFns.toYearMonth(date)
  },
  addMonths(yearMonth: string, months: number) {
    const date = new Date(`${yearMonth}-15`)
    date.setMonth(date.getMonth() + months)
    return YearMonthFns.toYearMonth(date)
  },
  getPrev(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    date.setMonth(date.getMonth() - 1)
    return YearMonthFns.toYearMonth(date)
  },
  getPrevYear(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    date.setFullYear(date.getFullYear() - 1)
    return YearMonthFns.toYearMonth(date)
  },
  getStartingDayOfWeek(yearMonth: string) {
    const date = new Date(`${yearMonth}-01T00:00`)
    return date.getDay()
  },
  getDaysInMonth(yearMonth: string) {
    const date = new Date(`${yearMonth}-15`)
    const daysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    return daysInMonth
  },
  isAfter(yearMonth: string, yearMonth2: string) {
    const date1 = new Date(`${yearMonth}-15`)
    const date2 = new Date(`${yearMonth2}-15`)
    return date1.getTime() > date2.getTime()
  },
  isBefore(yearMonth: string, yearMonth2: string) {
    const date1 = new Date(`${yearMonth}-15`)
    const date2 = new Date(`${yearMonth2}-15`)
    return date1.getTime() < date2.getTime()
  }
}
